export default __webpack_public_path__ + "upload/fb.2391d0cc.svg";